import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import { categoryImages } from "@/mocks/home";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-1 font-heading">
              <span className="text-foreground-400">Nos</span>
              <br />
              <span className="italic text-foreground-900">Catégories</span>
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed font-body">
            {t("home.categories.desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative block overflow-hidden rounded-2xl bg-background-100 hover:shadow-lg transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="aspect-square w-full overflow-hidden">
                <img
                  src={categoryImages[index] || categoryImages[0]}
                  alt={`${cat.name} collection`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width={600}
                  height={600}
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold mb-2 font-body uppercase tracking-wider">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}